import request from "@/utils/request";
//获取授权业务页面所有数据，分楼层展示
function getAuthBusinessPage() {
    return request.get('/cms/section/ac_auth_business')
}
export default {
    getAuthBusinessPage
}